import React, { useEffect, useState } from 'react'
import {
  Input,
  Row,
  Col,
  Card,
  Button,
  message,
  Upload,
  Tabs,
  Select,
  notification,
  Table
} from 'antd'
import axios from 'axios'
import Cookies from 'js-cookie'
import { get_v10_url } from '../utils/commonUtilities'
import { SettingOutlined, LockFilled } from '@ant-design/icons'

const lockIcon = (
  <svg width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7.89 4.82L6.25 3.16C6.61681 2.22836 7.25557 1.4287 8.08313 0.865101C8.91069 0.301501 9.88875 5.71153e-05 10.89 0C13.65 0 15.89 2.24 15.89 5V7H16.89C17.4204 7 17.9291 7.21071 18.3042 7.58579C18.6793 7.96086 18.89 8.46957 18.89 9V15.8L10.09 7H13.89V5C13.89 3.34 12.55 2 10.89 2C9.3 2 8 3.25 7.89 4.82ZM21 20.46L19.73 21.73L18.35 20.35C17.99 20.75 17.47 21 16.89 21H4.89C3.78 21 2.89 20.11 2.89 19V9C2.89 8.46957 3.10071 7.96086 3.47579 7.58579C3.85086 7.21071 4.35957 7 4.89 7H5L0 2L1.28 0.73L21 20.46ZM12.74 14.74L10.15 12.15C9.39 12.44 8.89 13.16 8.89 14C8.89 14.5304 9.10071 15.0391 9.47579 15.4142C9.85086 15.7893 10.3596 16 10.89 16C11.73 16 12.45 15.5 12.74 14.74Z" fill="#5E5D5D"/>
  </svg>
)

const ResetPassword = props => {
  const [postData, setPostData] = useState({
    email: '',
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  })
  const [showOldPass, setShowOldPass] = useState(false)
  const [showNewPass, setShowNewPass] = useState(false)
  const [showConfirmPass, setShowConfirmPass] = useState(false)

  const headers = {
    headers: { Authorization: `Bearer ${Cookies.get('token_medical_auth')}` }
  }

  useEffect(()=> {
    props.setActiveSideKey('7')
  }, [])

  useEffect(() => {
    axios
      .get(`${get_v10_url()}/professional/whoami`, headers)
      .then(res => {
        if (res.data?.success) {
          setPostData({
            ...postData,
            email: res.data.data.email
          })
        } else {
          console.error(res)
        }
      })
      .catch(err => {
        console.error(err)
      })
  }, [])

  const handleChange = e => {
    const { name, value } = e.target
    setPostData({
      ...postData,
      [name]: value
    })
  }

  const handleSubmit = () => {
    if (!validate()) {
      return
    }
    const body = {
      email: postData.email,
      password: postData.newPassword,
      oldPassword: postData.oldPassword
    }
    axios
      .post(`${get_v10_url()}/professional/updatePassword`, body, headers)
      .then(res => {
        if (res.data?.success) {
          notification.success({
            message: 'Success',
            description: 'Password changed successfully'
          })
          setPostData({
            email: postData.email,
            oldPassword: '',
            newPassword: '',
            confirmPassword: ''
          })
        } else {
          notification.error({
            message: 'Error',
            description: res.data?.msg
          })
        }
      })
      .catch(err => {
        console.error(err)
        notification.error({
          message: 'Error',
          description: err.response?.data?.msg ? err.response?.data?.msg : 'Please try again'
        })
      })
  }

  const validate = () => {
    if (postData.oldPassword === '') {
      notification.error({
        message: 'Error',
        description: 'Enter old password'
      })
      return false
    } else if (postData.newPassword === '') {
      notification.error({
        message: 'Error',
        description: 'Enter new password'
      })
      return false
    } else if (postData.confirmPassword === '') {
      notification.error({
        message: 'Error',
        description: 'Enter confirm password'
      })
      return false
    } else if (postData.newPassword !== postData.confirmPassword) {
      notification.error({
        message: 'Error',
        description: "Passwords don't match"
      })
      return false
    } else if (postData.oldPassword === postData.newPassword) {
      notification.error({
        message: 'Error',
        description: 'Old Password cannot be same as New Password'
      })
      return false
    } else if (postData.newPassword.length < 8) {
      notification.error({
        message: 'Error',
        description: 'New Password must contain at least 8 characters'
      })
      return false
    }
    return true
  }

  return (
    <div
      className='settings-page hospital-details-card'
      style={{ height: '100%' }}
    >
      <Card
        title={
          <div>
            <SettingOutlined style={{ marginRight: '10px' }} /> <span style={{fontSize:'1.2rem', fontWeight:'500'}}>Settings</span>
          </div>
        }
        headStyle={{
          marginLeft: '180px',
          height: '64px',
          position: 'relative',
          padding: '0px'
        }}
        bodyStyle={{ padding: '0px', height: 'calc(100% - 64px)' }}
        style={{ height: '100%' }}
      >
        <div style={{ height: '100%', padding: '20px', display: 'flex' }}>
          <div
            style={{
              width: '65%',
              height: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <img src='/icons/reset_password.svg' style={{ height: '70%' }} />
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-start',
              width: '35%',
              flexDirection: 'column'
            }}
          >
            <h1 style={{ fontSize: '4rem', marginBottom: '0px', lineHeight:'4.5rem', marginBottom:'1.25rem' }}>
              Re-Set New Password
            </h1>
            <h3
              style={{
                fontSize: '2rem',
                fontWeight: 'bold',
                marginBottom: '20px'
              }}
            >
              Create Your New Password
            </h3>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <label style={{ fontWeight: 'bold' }}>Old Password</label>
              <Input
                value={postData.oldPassword}
                name='oldPassword'
                onChange={handleChange}
                type={showOldPass ? 'text' : 'password'}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  border: '1px solid #00A82E',
                  width: '80%',
                  marginBottom: '20px'
                }}
                suffix={<div onClick={()=>setShowOldPass(!showOldPass)} style={{cursor:'pointer', marginTop:'5px'}}>{showOldPass ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div>}
              />
            </div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <label style={{ fontWeight: 'bold' }}>New Password</label>
              <Input
                value={postData.newPassword}
                name='newPassword'
                onChange={handleChange}
                type={showNewPass ? 'text' : 'password'}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  border: '1px solid #00A82E',
                  width: '80%',
                  marginBottom: '20px'
                }}
                suffix={<div onClick={()=>setShowNewPass(!showNewPass)} style={{cursor:'pointer', marginTop:'5px'}}>{showNewPass ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div>}
              />
            </div>
            <div
              style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <label style={{ fontWeight: 'bold' }}>Confirm New Password</label>
              <Input
                value={postData.confirmPassword}
                name='confirmPassword'
                onChange={handleChange}
                type={showConfirmPass ? 'text' : 'password'}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  border: '1px solid #00A82E',
                  width: '80%',
                  marginBottom: '20px'
                }}
                suffix={<div onClick={()=>setShowConfirmPass(!showConfirmPass)} style={{cursor:'pointer', marginTop:'5px'}}>{showConfirmPass ? <LockFilled style={{color:'#5E5D5D', fontSize:'20px'}}/> : lockIcon}</div>}
              />
            </div>

            <Button
              style={{
                width: '80%',
                background: '#00A82E',
                height: '50px',
                color: 'white',
                borderRadius: '10px',
                fontWeight: 'bold',
                marginTop: '20px'
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </div>
        </div>
      </Card>
    </div>
  )
}

export default ResetPassword
